import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Broadcast } from 'videoservice-openapi-react';
import { useBroadcastStore, useUpdateBroadcastInCache } from 'entities/broadcast';

export const useRemoveEvent = (broadcast: Broadcast) => {
  const { t } = useTranslation()
  const removeEvent = useBroadcastStore(state => state.removeMapping);
  const { updateBroadcastItemCache } = useUpdateBroadcastInCache();

  const removeEventMutation = useMutation({
    mutationFn: (sbSportEventId: number) => {
      return removeEvent({
        broadcastId: broadcast.id,
        sbSportEventId,
      });
    },
    meta: {
      errorMessages: {
        404: (sbSportEventId: number) => t('error.event not found', { eventId: sbSportEventId }),
        403: (sbSportEventId: number) => t('error.event unmap access denied', { eventId: sbSportEventId })
      },
    },
    onSuccess(data) {
      updateBroadcastItemCache(data);
    },
  });

  return {
    removeEventMutation,
  };
};
